var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3684 29C10.5868 29 9.91776 28.716 9.36118 28.1481C8.80461 27.5802 8.52632 26.8975 8.52632 26.1H14.2105C14.2105 26.8975 13.9322 27.5802 13.3757 28.1481C12.8191 28.716 12.15 29 11.3684 29ZM19.8947 15.95V11.6H15.6316V8.7H19.8947V4.35H22.7368V8.7H27V11.6H22.7368V15.95H19.8947ZM0 24.65V21.75H2.84211V11.6C2.84211 9.59417 3.43421 7.81188 4.61842 6.25313C5.80263 4.69438 7.3421 3.67333 9.23684 3.19V2.175C9.23684 1.57083 9.44408 1.05729 9.85855 0.634375C10.273 0.211458 10.7763 0 11.3684 0C11.9605 0 12.4638 0.211458 12.8783 0.634375C13.2928 1.05729 13.5 1.57083 13.5 2.175V3.19C13.8316 3.28667 14.1572 3.38938 14.477 3.49813C14.7967 3.60688 15.0987 3.74583 15.3829 3.915C15.0276 4.25333 14.7079 4.62188 14.4237 5.02063C14.1395 5.41938 13.8908 5.84833 13.6776 6.3075C13.3224 6.13833 12.9493 6.01146 12.5586 5.92688C12.1678 5.84229 11.7711 5.8 11.3684 5.8C9.80526 5.8 8.4671 6.36792 7.35395 7.50375C6.24079 8.63958 5.68421 10.005 5.68421 11.6V21.75H17.0526V17.69C17.4789 17.9558 17.9289 18.1733 18.4026 18.3425C18.8763 18.5117 19.3737 18.6446 19.8947 18.7413V21.75H22.7368V24.65H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.c45259a283b03cff26a0ae87707a7c19.svg";
export { ForwardRef as ReactComponent };